var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLandit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 582,
    height: 86,
    viewBox: "0 0 582 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M345.85 20.5599H339.45V81.0499H345.85V20.5599Z",
    fill: "#231815"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.66 81.1499H0.559998V0.579956H7.07V75.3H45.66V81.1499Z",
    fill: "#231815"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M213.16 85.6699L170 32.3399V80.9099H163.82V15.9199L206.65 69.2499V20.0699H213.16V85.6699Z",
    fill: "#231815"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M276.96 81.46C276.93 81.46 276.91 81.46 276.89 81.46H255.09V33.6H261.6V75.61H276.93C277.17 75.61 287.08 75.54 293.84 68.81C298.19 64.48 300.4 58.24 300.4 50.27V50.05C300.4 41.77 298.14 35.37 293.67 31.05C286.9 24.49 277.12 24.72 277.02 24.72H254.96V18.87H276.92C277.3 18.85 289.09 18.52 297.69 26.8C303.37 32.27 306.25 40.09 306.25 50.05V50.27C306.25 59.88 303.44 67.53 297.91 73C289.57 81.26 278.06 81.46 276.96 81.46Z",
    fill: "#231815"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M100.69 16.66L100.21 17.68H101.17L100.69 16.66Z",
    fill: "#231815"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M100.21 17.68L70.4 81.05H76.86L100.69 30.39L124.52 81.05H130.98L101.17 17.68H100.21Z",
    fill: "#231815"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M489.07 42.7999H485.31V80.1099H489.07V42.7999Z",
    fill: "#231815"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M529.99 80.1099H526.33V65.7099C526.33 62.0299 525.43 59.3499 523.65 57.7399C521.76 56.0299 519.18 55.6799 517.34 55.6799C511.63 55.7699 508.35 58.9899 508.35 64.5299V80.1099H504.69V52.7299H508.35V55.2699C510.8 53.0299 514.41 52.0299 517.37 52.1199C520.83 52.1199 523.72 53.0499 525.93 54.8999C528.63 57.1799 529.99 60.8199 529.99 65.7199V80.1099Z",
    fill: "#231815"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M556.14 81.3899C547.96 81.3899 541.79 75.2599 541.77 67.1299C541.77 67.1199 541.77 67.1099 541.77 67.1099C541.77 67.0999 541.77 67.0899 541.77 67.0899C541.79 58.9299 547.96 52.7899 556.12 52.7899C562.43 52.7899 567.76 56.5299 569.7 62.3299L570.22 63.8699H566.3L566.03 63.0899C564.14 57.6999 558.93 56.3099 556.18 56.3599C553.03 56.3999 550.94 57.2299 548.48 59.4199C546.63 61.0999 545.42 64.1199 545.42 67.0999C545.42 73.2199 550.02 77.8399 556.11 77.8399C561.43 77.7999 564.95 74.4499 565.96 71.3699L566.22 70.5699H570.17L569.64 72.1199C567.73 77.7199 562.55 81.2799 556.14 81.3899Z",
    fill: "#231815"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M581.45 75.2099H576.71V79.9499H581.45V75.2099Z",
    fill: "#231815"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M416.04 0.579956H409.64V32.56H416.04V0.579956Z",
    fill: "#231815"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M372.81 37.54V43.38H409.64V81.13H416.04V43.38H452.32V37.54H372.81Z",
    fill: "#231815"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandit);
export default __webpack_public_path__ + "static/media/landit.471579f0a4596323c7785f88bffe5583.svg";
export { ForwardRef as ReactComponent };